module.exports = __webpack_public_path__ + "static/map-bf5cbf5edf6036d256d5efc01fb36249.svg";